const BASE = '$appbase'

export const MODAL_CURRENT = `${BASE}/modal`
export const PAGE_CURRENT = `${BASE}/page/info`
export const TEAMS = `${BASE}/teams`